import { Tab, Tabs } from '@material-ui/core';
import React, { FC } from 'react';

interface ShopOrderTabsProps {
  tab?: number;
  onTabChange?: (tab: number) => void;
}

const ShopOrderTabs: FC<ShopOrderTabsProps> = ({ tab, onTabChange }) => {
  const handleChange = (_e: any, newValue: number) => {
    if (onTabChange) {
      onTabChange(newValue);
    }
  };

  return (
    <Tabs
      value={tab || 0}
      onChange={handleChange}
      indicatorColor="primary"
      textColor="primary"
      variant="scrollable"
      scrollButtons="auto"
      aria-label="tabs"
    >
      <Tab label="Shop Items" />
      <Tab label="History" />
    </Tabs>
  );
};

export default ShopOrderTabs;
